import getReducerHandler from '../../../providers/getReducerHandler'
// import handleReducerSimpleSetter from '../../../providers/handleReducerSimpleSetter' // uncomment if need to set single property

/*
 * --- INDIVIDUAL ACTION HANDLERS ---
 * (Set multiple values & merge/processing logic only, otherwise use handleReducerSimpleSetter)
 */

const handleSetUpdates = (state, action) => ({ ...state, ...action.updates })

// --- Handlers registry ---
const handlers = {
  SET_UPDATES: handleSetUpdates,
}

export default function activityNavReducer(state, action) {
  return getReducerHandler(state, action, handlers)
}
